import axios from "axios";

export type GoogleTilesSessionResponse = {
    session: string;
    expiry: string;
    tileWidth: number;
    tileHeight: number;
    imageFormat: "jpeg" | "png";
};

export default class GoogleTilesService {
    public async createSatelliteSession(publicGoogleAccessToken: string): Promise<GoogleTilesSessionResponse> {
        const { data } = await axios.post<GoogleTilesSessionResponse>(
            "https://tile.googleapis.com/v1/createSession",
            { mapType: "satellite", language: "en-US", region: "US", },
            { params: { key: publicGoogleAccessToken } }
        );

        return data;
    }
}
